var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSojuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8511 29.7539H70.3711",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.018 114.114V106.352V86.2632C104.018 85.4264 103.843 84.5989 103.504 83.8337L101.504 79.3164",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7892 79.3164L56.6208 83.7459C56.2188 84.5672 56.0098 85.4695 56.0098 86.3839V106.352V151.335V157.33C56.0098 160.644 58.6961 163.33 62.0098 163.33H103.809C103.925 163.33 104.019 163.236 104.019 163.12V163.12",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2345 76.3537C58.2808 80.3402 61.1829 84.9942 65.6223 84.9942H94.7994C99.1378 84.9942 102.042 80.5317 100.286 76.5648L91.5661 56.8736C91.2341 56.1239 91.0593 55.3141 91.0525 54.4942L90.7649 19.9501C90.7375 16.656 88.0593 14 84.7651 14H76.3454C73.0244 14 70.3352 16.6976 70.3454 20.0185L70.4505 54.0984C70.4534 55.02 70.2439 55.9298 69.8383 56.7574L60.2345 76.3537Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.019 106.352H56.0098",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2703 151.335H56.0098",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9339 39.5635H70.4082",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.059 117.461C137.462 121.877 141.348 128.432 140.598 135.637C138.102 159.371 114.852 163.33 107.007 163.33C106.084 163.33 105.078 163.285 104.017 163.12C99.8117 162.462 94.9112 159.966 92.2689 151.335C91.0895 147.467 90.3672 142.357 90.3672 135.637C90.3672 126.256 95.9077 118.128 104.017 114.114C105.809 113.227 107.729 112.542 109.75 112.094",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.869 111.572C133.449 118.018 127.296 121.455 123.118 119.243C118.94 117.03 118.318 110.009 121.737 103.554C123.751 99.7586 128.16 97.7733 131.446 96.7822C133.835 96.0616 136.27 97.3502 137.018 99.7311C138.046 103.007 138.882 107.771 136.869 111.572Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.329 101.013C121.682 97.5988 117.888 95.5582 114.975 94.443C112.727 93.5826 110.286 94.6012 109.297 96.7959C107.884 99.9347 106.443 104.665 108.042 108.739C109.916 113.484 113.272 116.912 116.627 117.964C117.285 118.183 117.953 118.293 118.611 118.293C119.379 118.32 120.129 118.202 120.842 117.918C120.997 117.854 121.153 117.79 121.29 117.717",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.312 142.621C116.232 139.687 120.959 125.396 122.614 118.941",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSojuIcon);
export default __webpack_public_path__ + "static/media/soju-icon.ee1d736aa3c3f81d240e9e79b94f87e1.svg";
export { ForwardRef as ReactComponent };